import React, { useState, useEffect } from 'react';
import Button from './Button';
import IOSInstallModal from './IOSInstallModal';

interface IOSInstallPromptProps {
  onDismiss: () => void;
}

const IOSInstallPrompt: React.FC<IOSInstallPromptProps> = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if it's iOS
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(ios);

    // Check if already installed as PWA
    const standalone = window.matchMedia('(display-mode: standalone)').matches;
    setIsStandalone(standalone);

    // Show prompt for iOS users who haven't installed the app
    if (ios && !standalone) {
      // Delay showing the prompt to avoid immediate popup
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    onDismiss();
  };

  const handleInstall = () => {
    setShowModal(true);
  };

  if (!isVisible || !isIOS || isStandalone) {
    return null;
  }

  return (
    <>
      <div className='fixed bottom-4 left-4 right-4 z-50'>
        <div className='bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4'>
          <div className='flex items-start space-x-3'>
            <div className='flex-shrink-0'>
              <span className='text-2xl'>📱</span>
            </div>
            <div className='flex-1 min-w-0'>
              <p className='text-sm font-medium text-gray-900 dark:text-white'>
                Add Riddl to Home Screen
              </p>
              <p className='text-sm text-gray-500 dark:text-gray-400 mt-1'>
                Tap the share button <span className='font-mono'>⎋</span> then
                "Add to Home Screen" for the best experience.
              </p>
            </div>
          </div>
          <div className='flex space-x-2 mt-3'>
            <Button
              variant='primary'
              size='sm'
              onClick={handleInstall}
              className='flex-1'
            >
              Show Instructions
            </Button>
            <Button
              variant='secondary'
              size='sm'
              onClick={handleDismiss}
              className='flex-1'
            >
              Maybe Later
            </Button>
          </div>
        </div>
      </div>

      <IOSInstallModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default IOSInstallPrompt;
